import { Component, EventEmitter, Output, Input, signal, OnInit } from '@angular/core';
import { form, required, FormField } from '@angular/forms/signals';

import { NgxEditorComponent, NgxEditorMenuComponent, Editor, Toolbar, toDoc, toHTML } from 'ngx-editor';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'atom-wysiswyg',
  standalone: true,
  imports: [NgxEditorComponent, NgxEditorMenuComponent, FormsModule],
  templateUrl: './wysiswyg.component.html',
  styleUrl: './wysiswyg.component.css'
})
export class WysiswygComponent implements OnInit {

  @Input() inputHtml: string | undefined;
  @Input() placeholder: string = 'Type here...';
  // HTML Content
  @Output() htmlContentChange = new EventEmitter<string>();

  // Wig Object - JSON structure
  @Output() htmlContentWysiwygChange = new EventEmitter<any>();

  // htmlContent = signal<string>('<p>Hello World</p>');

  // htmlContentModel = signal({
  //   htmlContent: '<p>Hello World</p>'
  // })
  // htmlContentForm = form(this.htmlContentModel, (schemaPath) => {
  //   required(schemaPath.htmlContent, { message: 'HTML content is required' });
  // })

  html: string | undefined;

  rawWyg: any;
  editor: Editor = new Editor();

  toolbar: Toolbar = [
    ['bold', 'italic', 'underline'],
    ['link'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  bulletsToolbar: Toolbar = [
    ['bold', 'italic', 'underline'],
    ['ordered_list', 'bullet_list'],
    ['link'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  colorPresets = ['red', '#FF0000', 'rgb(255, 0, 0)'];

  ngOnInit(): void {
    console.log('ngOnInit()', this.inputHtml);
    this.editor = new Editor();
    if (this.inputHtml) {
      this.html = this.inputHtml;
      this.rawWyg = toDoc(this.inputHtml!);
    }
  }

  updatedWig(event: any): void {
    console.log('updatedWig()', event);
    console.log('HTML typed: ', this.html);
    let rawHtml = toHTML(this.rawWyg);
    console.log('Raw HTML: ', rawHtml);

    this.htmlContentChange.emit(rawHtml);
  }

  /** Emit current editor HTML (e.g. before save) without relying on focus-out. */
  flushHtmlToParent(): void {
    const rawHtml = this.rawWyg != null ? toHTML(this.rawWyg) : '';
    this.htmlContentChange.emit(rawHtml);
  }

  /** Apply HTML from the parent when `[inputHtml]` is not enough (e.g. after ngOnInit). */
  applyExternalHtml(html: string): void {
    const normalized = html.trim().length > 0 ? html : '<p></p>';
    this.html = normalized;
    this.rawWyg = toDoc(normalized);
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

}
